<!--报表 销售报表-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="客户：">
            <el-select filterable v-model="searchForm.TC_ID" placeholder="请选择客户" clearable>
              <el-option v-for="item in customer" :key="item.TC_ID" :label="item.TC_NAME" :value="item.TC_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select filterable v-model="searchForm.PROJECT_ID" placeholder="请选择项目点" clearable>
              <el-option v-for="item in projects" :key="item.PROJECT_ID" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn" @click="fliterData">筛选</el-button>
            <el-button type="primary" plain class="btn" @click="$_exportForm" v-if="fun_dic[113060101]">导出</el-button>
            <el-button type="primary" plain class="btn" @click="exportDailySummary" v-if="fun_dic[113060102]">
              日汇总导出
            </el-button>
            <el-button type="primary" plain class="btn" @click="exportByDate" v-if="fun_dic[113060103]">分日期导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <el-table-column label="序号" prop="index" width="50px"></el-table-column>
          <el-table-column label="客户" prop="TC_NAME" min-width="100px"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME" min-width="100px"></el-table-column>
          <el-table-column v-for="item in kinds" :key="item.TYPE_ID" :label="item.TYPE_NAME"
            :prop="String(item.TYPE_ID)"></el-table-column>
          <el-table-column label="合计" prop="TOTAL_FEE_ROW"></el-table-column>
          <el-table-column label="操作" fixed="right" width="70px">
            <template slot-scope="scope">
              <el-button v-if="scope.$index + 1 < tableData.length" type="text" @click="detail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { salesStatements, exportForm } from 'api/returnWare';
import { haveDSXMDFun } from 'api/sellOrder';
import http from '@/assets/common/http';
import { getActionFun } from '@/assets/api/login';

export default {
  data() {
    return {
      PAGE_ID: '1130601',
      fun_dic: { 113060101: 0, 113060102: 0, 113060103: 0 },
      searchForm: {},
      tableData: [],
      kinds: [],
      customer: [],
      projects: [],
    };
  },
  created() {
    this.searchForm = this.$store.state.SALESSTATEMENTS_ALL;
    this.queryData();
    this.queryPro();
    this.queryBeforeFun();
  },
  methods: {
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 拉取项目点
    // ----拉取项目点
    queryPro() {
      haveDSXMDFun()
        .then((result) => {
          this.projects = result.length > 0 ? result[0].project : [];
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 导出
    $_exportForm() {
      const params = {};
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.DATE != null) {
        params.START_DAY = this.searchForm.DATE[0];
        params.END_DAY = this.searchForm.DATE[1];
      }
      if (!this.searchForm.DATE) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      exportForm(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          window.location.href = res[0].FILE_PATH;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    fliterData() {
      this.queryData();
    },
    // 获取界面数据
    queryData() {
      this.$store.dispatch('SALESSTATEMENTS_ALL', { ...this.searchForm });
      const params = {
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.DATE != null) {
        params.START_DAY = this.searchForm.DATE[0];
        params.END_DAY = this.searchForm.DATE[1];
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      salesStatements(params).then((result) => {
        if (result.length == 0) {
          this.tableData = [];
          this.kinds = [];
          this.$message.show({ text: '暂无数据', type: 'error' });
        } else {
          this.tableData = result[0].value.map((item, index) => ({
            ...item,
            index: index + 1,
          }));
          this.kinds = result[1].TYPE_LIST;
          this.customer = result[2].value0.TC_LIST;

          const lastRow = this.tableData.at(-1);
          lastRow.index = '总计';
          lastRow.TC_NAME = '';
          for (const key in lastRow) {
            if (typeof lastRow[key] == 'number') {
              lastRow[key] = lastRow[key].toFixed(2);
            }
          }
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportDailySummary() {
      if (!this.searchForm.DATE) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 63,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        START_DAY: this.searchForm.DATE[0],
        END_DAY: this.searchForm.DATE[1],
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      http.post(params).then((res) => {
        if (res[0]) {
          window.location.href = res[0].FILE_PATH;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportByDate() {
      if (!this.searchForm.DATE) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 64,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        START_DAY: this.searchForm.DATE[0],
        END_DAY: this.searchForm.DATE[1],
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      http.post(params).then((res) => {
        if (res[0]) {
          window.location.href = res[0].FILE_PATH;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    detail({
      TC_ID, TC_NAME, PROJECT_ID, PROJECT_NAME,
    }) {
      sessionStorage.setItem('salesStatementsDetailTitle', JSON.stringify({
        TC_ID, TC_NAME, PROJECT_ID, PROJECT_NAME,
      }));
      sessionStorage.setItem('dateRange', JSON.stringify(this.searchForm.DATE || []));
      this.$router.push({ path: '/salesStatementsDetail/detail' });
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/tableManage/salesStatements.vue